import { USER_ROLES_RESTRICTED, USER_ROLES_VIEWONLY } from "@gtmhub/shared/utils/user-roles";
import { IListColumn, IMetricHistory } from "../models/models";

export const userHasOnlyResctrictedRole = (roles: string[]): boolean => {
  if (!roles) return false;

  if (roles.length === 1 && roles[0] === USER_ROLES_RESTRICTED) {
    return true;
  }

  if (roles.length === 1 && roles[0] === USER_ROLES_VIEWONLY) {
    return true;
  }

  return false;
};

export const getLatestSnapshotCustomFieldValue = (fieldName: string, latestSnapshot: IMetricHistory): string => {
  const custFieldKey = fieldName.split(".")[2];
  return latestSnapshot?.customFields?.[custFieldKey] || "";
};

export const isCustomFieldColumn = (column: IListColumn): boolean => {
  return column.fieldName.startsWith("customFields") || column.fieldName.startsWith("latestSnapshot.customFields");
};
